export const isDebugLogsEnabled =
  import.meta.env.VITE_ENABLE_DEBUG_LOGS === "true";

export function debugLog(...args: unknown[]) {
  if (!isDebugLogsEnabled) {
    return;
  }
  console.log(...args);
}
